import { getIsCheckedProducts } from 'common/helpers/get-is-checked-products.helper';
import { TBasketItem } from '../types/basket-item.type';
import { TComplimentaryProductsState } from '../types/complimentary-products-state.type';
import { TCheckedType } from '../types/index.type';

export const getComplimentaryProductInfoForBasket = ({
  complimentaryProducts,
  checkedProducts,
}: {
  complimentaryProducts: TComplimentaryProductsState;
  checkedProducts: [] | TCheckedType;
}): TBasketItem[] => {
  if (checkedProducts.length) {
    return Object.values(complimentaryProducts)
      .map(item => {
        const isCheckedProduct = getIsCheckedProducts({
          checkedProducts,
          productId: item.productId,
        });
        return isCheckedProduct && item.total.requiredQuantity > 0
          ? {
              code: item.productId,
              quantity: item.total.requiredQuantity,
            }
          : null;
      })
      .filter(item => item !== null) as TBasketItem[];
  }
  return [];
};
